export const VERIFICATION_STATUS_LABELS: Record<string, string> = {
  unverified: 'Unverified',
  pending: 'Pending review',
  pending_review: 'Pending review',
  verified: 'Verified',
  approved: 'Verified',
  rejected: 'Rejected',
  revoked: 'Verification revoked',
};

export const APPROVABLE_VERIFICATION_STATUSES = new Set(['', 'unverified', 'pending', 'pending_review', 'rejected', 'revoked']);
export const VERIFIED_VERIFICATION_STATUSES = new Set(['verified', 'approved']);
export const REJECTABLE_VERIFICATION_STATUSES = new Set(['', 'unverified', 'pending', 'pending_review']);
export const REVOCABLE_VERIFICATION_STATUSES = new Set(['verified', 'approved']);

export type VerificationAction = 'approve' | 'reject' | 'revoke';

export const DEFAULT_VERIFICATION_REASONS: Record<VerificationAction, string> = {
  approve: 'Talent reviewed and approved for Core Network participation.',
  reject: '',
  revoke: '',
};

export const getNormalizedVerificationStatus = (status?: string | null): string => String(status || 'unverified').toLowerCase();

export const getVerificationStatusLabel = (status?: string | null): string => {
  const normalized = getNormalizedVerificationStatus(status);
  return VERIFICATION_STATUS_LABELS[normalized] || String(status || 'Unverified');
};

export const isVerificationApproved = (status?: string | null): boolean => (
  VERIFIED_VERIFICATION_STATUSES.has(getNormalizedVerificationStatus(status))
);

export const canApproveVerification = (status?: string | null): boolean => (
  APPROVABLE_VERIFICATION_STATUSES.has(getNormalizedVerificationStatus(status))
);

export const canRejectVerification = (status?: string | null): boolean => (
  REJECTABLE_VERIFICATION_STATUSES.has(getNormalizedVerificationStatus(status))
);

export const canRevokeVerification = (status?: string | null): boolean => (
  REVOCABLE_VERIFICATION_STATUSES.has(getNormalizedVerificationStatus(status))
);

export const buildVerificationPayload = (action: VerificationAction, reason: string) => {
  if (action === 'approve') {
    return { verified: true, accountStatus: 'verified', reason };
  }

  if (action === 'reject') {
    return { verified: false, accountStatus: 'rejected', reason };
  }

  return { verified: false, accountStatus: 'unverified', reason };
};
